import {useEffect} from "react";

interface CookieDeclarationProps {
}

const CookieDeclaration = ({}: CookieDeclarationProps) => {

  useEffect(() => {
    const parent = document.getElementById("cookie-declaration");
    const script = document.createElement('script');

    script.id = "CookieDeclaration";
    script.src = "https://consent.cookiebot.com/f22e2029-489f-4964-84c5-6bb00b53571d/cd.js";
    script.async = true;

    if(!parent) return ;
    parent.appendChild(script);

    return () => {
      parent.removeChild(script);
    }
  }, []);

  return (
    <>
      <div className="d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-baseline mt-2">
        <h1 className="page-title">Cookie information</h1>
      </div>
      <div className="row">
        <div className="col">
          <div className="mb-4 slide-up-fade-in p-4 bg-white rounded rounded-lg">
            <div id="cookie-declaration"/>
          </div>
        </div>
      </div>
    </>
  )
}

export default CookieDeclaration;